export default "__VITE_ASSET__k8N5feBU__"